function highlight(text, lookup) {
	let start = text.toLowerCase().indexOf(lookup.toLowerCase());
	let end   = start + lookup.length;

	if (start < 0) {
		return text;
	}
	else {
		let out = text.slice(0,start) +
			'<span class="highlight">' +
			text.substring(start, end) +
			'</span>';

		if (text.length - end > 0)
			out += text.slice(-1 * (text.length - end));

		return out;
	}
}

var suggestionsResults = {};

function searchSuggestions(searchbox) {
	let ctx = document.getElementById('suggestions-wrapper');

	ctx.replaceChildren();

	if (searchbox.value.length >= 2) {
		let parent = document.querySelector('#search-overlay .container');

		parent.classList.add('--loading');

		let wpAction     = 'get_search_suggestions';
		let wpNonce      = document.getElementById('search-input').dataset.nonce;
		let lookupString = searchbox.value;

		fetch(mswpt_vars.ajax_url + '?action=' + wpAction + '&nonce=' + wpNonce + '&chars=' + lookupString, {
			method: 'POST',
			headers:{
				'Content-Type': 'application/json',
			}
			})
			.then(res => res.json())
			.then(response => {
				console.log(response);

				if (response.success) {
					if (response.data != null) {
						ctx.replaceChildren();
						
						for (var k in response.data) {
							let suggGroup = document.createElement('ul');

							suggGroup.setAttribute('data-title', response.data[k].label);
							response.data[k].items.forEach( (item) => {
								let suggItem = document.createElement('li');

								suggItem.innerHTML = '<a href="' + item.url + '">' + highlight(item.title, lookupString) + '</a>';

								if ('' != item.types) {
									suggItem.innerHTML += ' <span class="text-dark-grey">' + item.types + '</span>';
								}

								suggGroup.appendChild(suggItem);

							});
							parent.classList.remove('--loading');
							ctx.appendChild(suggGroup);
						}

						var data            = new FormData();
						let suggestionslist = ctx.querySelectorAll('ul');

						data.append('action', 'save_search_suggestions');
						data.append('nonce', document.getElementById('search-input').dataset.nonce);
						data.append('search_text', response.msrch.search_text);
						data.append('posts', JSON.stringify(response.msrch.posts));

						suggestionslist.forEach( (item) => {
							let links = item.querySelectorAll('li a');

							links.forEach( (link) => {
								link.addEventListener('click', (e) => {
									e.preventDefault();

									fetch(mswpt_vars.ajax_url, {
										method: 'POST',
										body: data
										})
										.then((res) => res.json())
										.then(response => {
											window.location.href = link.href;
										})
										.catch(error => {
											console.error(error);
									});
								});
							});
						});
					}
					else {
						ctx.replaceChildren();
						parent.classList.remove('--loading');
					}
				}
			})
			.catch(error => {
				console.error(error);
		});
	}
}

const debouncedSearch = debounce(searchSuggestions, 300);
let mobileSearcInput  = document.querySelector('#mobile-search-box .search-input');

if (mobileSearcInput) {
	mobileSearcInput.addEventListener('focusin', (e) => {
		lockPageScroll();
		document.body.classList.add('--search-open', '--dark-theme');
	});
}

let searchOpen = document.querySelector('#search-open');

if (searchOpen) {
	searchOpen.addEventListener('click', (e) => {

		if (!document.body.classList.contains('--search-open')) {
			lockPageScroll();
			document.body.classList.add('--search-open', '--dark-theme');
			document.querySelector('#desktop-search-box .search-input').focus();
		}
	});
}

let searchInput = document.querySelectorAll('.search-box .search-input');

if (searchInput) {
	searchInput.forEach( (item) => {
		item.addEventListener('input', (e) => {
			debouncedSearch(e.target);
		});

		/*
		item.addEventListener('focusout', (e) => {
			document.body.classList.remove('--search-open', '--dark-theme');
			unlockPageScroll();
		});
		*/
	});
}

let searchClose = document.querySelectorAll('.search-close');

if (searchClose) { 
	searchClose.forEach( (item) => {
		item.addEventListener('click', (e) => {
			document.body.classList.remove('--search-open', '--dark-theme');
			unlockPageScroll();
		});
	});
}
